import $ from 'jquery'

// On click some element -> submit closest form
$('[data-behavior~="submit-form-on-click"]').on('click', function () {
  $(this).closest('form').trigger('submit')
})
